module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[40]405.bfac8b0.woff2";